var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pagebody',{staticStyle:{"margin":"0 auto","float":"none"},attrs:{"loading":false}},[_c('div',{staticStyle:{"height":"100px"}}),_c('h1',{staticClass:"transfer_title"},[_vm._v("跳转中，请稍后... ...")]),_c('div',{staticStyle:{"height":"250px"}}),_c('div',{staticStyle:{"display":"none"},domProps:{"innerHTML":_vm._s(_vm.dom)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }